export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          焦点推荐
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-10 md:mb-14 max-w-xl mx-auto">
          本周最受瞩目的刃牙漫画热门篇章
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          <div className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-300 hover:border-primary-200/60 cursor-pointer">
            <div className="relative aspect-[3/4] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Manga%20cover%20style%20illustration%20with%20intense%20fighter%20silhouette%2C%20dramatic%20red%20and%20black%20ink%20wash%2C%20Japanese%20comic%20aesthetic%2C%20bold%20composition%2C%20warm%20lighting%2C%20powerful%20energy%2C%20no%20text&width=600&height=800&seq=carousel-01&orientation=portrait"
                alt="刃牙VS勇次郎 最终决战"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                <span className="text-white text-xs font-medium bg-primary-500/90 px-2 py-0.5 rounded-full whitespace-nowrap">爆款</span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-heading text-foreground-950 mb-1 line-clamp-2">刃牙VS勇次郎 最终决战</h3>
              <p className="text-xs text-foreground-400">父子巅峰对决·全网热议</p>
            </div>
          </div>

          <div className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-300 hover:border-primary-200/60 cursor-pointer">
            <div className="relative aspect-[3/4] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Manga%20style%20intense%20training%20scene%20silhouette%2C%20warm%20amber%20and%20dark%20background%2C%20Japanese%20comic%20aesthetic%2C%20dramatic%20lighting%2C%20muscular%20figure%2C%20no%20text&width=600&height=800&seq=carousel-02&orientation=portrait"
                alt="地下竞技场 死亡囚犯篇"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                <span className="text-white text-xs font-medium bg-accent-500/90 px-2 py-0.5 rounded-full whitespace-nowrap">经典</span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-heading text-foreground-950 mb-1 line-clamp-2">地下竞技场 死亡囚犯篇</h3>
              <p className="text-xs text-foreground-400">五大死刑犯挑战赛</p>
            </div>
          </div>

          <div className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-300 hover:border-primary-200/60 cursor-pointer">
            <div className="relative aspect-[3/4] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Manga%20tournament%20arena%20illustration%20with%20dramatic%20lighting%2C%20warm%20red%20and%20amber%20background%2C%20Japanese%20comic%20style%2C%20epic%20crowd%20atmosphere%2C%20bold%20composition%2C%20no%20text&width=600&height=800&seq=carousel-03&orientation=portrait"
                alt="中国大擂台赛 完整收录"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                <span className="text-white text-xs font-medium bg-secondary-500/90 px-2 py-0.5 rounded-full whitespace-nowrap">精选</span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-heading text-foreground-950 mb-1 line-clamp-2">中国大擂台赛 完整收录</h3>
              <p className="text-xs text-foreground-400">东西方格斗技大碰撞</p>
            </div>
          </div>

          <div className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-300 hover:border-primary-200/60 cursor-pointer">
            <div className="relative aspect-[3/4] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Manga%20style%20epic%20battle%20scene%20with%20speed%20lines%2C%20warm%20crimson%20and%20dark%20background%2C%20dramatic%20ink%20brush%20effect%2C%20Japanese%20comic%20aesthetic%2C%20intense%20action%2C%20no%20text&width=600&height=800&seq=carousel-04&orientation=portrait"
                alt="刃牙道 最新连载"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                <span className="text-white text-xs font-medium bg-primary-500/90 px-2 py-0.5 rounded-full whitespace-nowrap">新番</span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-heading text-foreground-950 mb-1 line-clamp-2">刃牙道 最新连载</h3>
              <p className="text-xs text-foreground-400">每周同步更新</p>
            </div>
          </div>

          <div className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-300 hover:border-primary-200/60 cursor-pointer">
            <div className="relative aspect-[3/4] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Manga%20character%20roster%20style%20illustration%2C%20multiple%20fighter%20silhouettes%2C%20warm%20red%20and%20amber%20gradient%2C%20Japanese%20comic%20aesthetic%2C%20dramatic%20lighting%2C%20epic%20lineup%2C%20no%20text&width=600&height=800&seq=carousel-05&orientation=portrait"
                alt="花山薰外传 拳王之路"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                <span className="text-white text-xs font-medium bg-accent-500/90 px-2 py-0.5 rounded-full whitespace-nowrap">外传</span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-heading text-foreground-950 mb-1 line-clamp-2">花山薰外传 拳王之路</h3>
              <p className="text-xs text-foreground-400">黑道最强男人的传奇</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}